import React from 'react';

const Pagination = ({ currentPage, totalItems, itemsPerPage, onPageChange, onItemsPerPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div>
        <label className="me-2">Sahifalash:</label>
        <select
          value={itemsPerPage}
          onChange={e => onItemsPerPageChange(Number(e.target.value))}
          className="form-select d-inline-block w-auto"
        >
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
      <nav>
        <ul className="pagination mb-0">
          <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
            <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
              «
            </button>
          </li>
          {pageNumbers.map(number => (
            <li key={number} className={`page-item${currentPage === number ? ' active' : ''}`}>
              <button className="page-link" onClick={() => onPageChange(number)}>{number}</button>
            </li>
          ))}
          <li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>
            <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
              »
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination; 